<template>
  <div class="learingMy">
    <commonHeader></commonHeader>
    <div tyle="width:100%;height:240px;">
       <div id="map" style="width:100%;z-index:8;"  v-bind:style="{ height: heightSize + 'px' }"></div>
    </div>

    <mt-actionsheet
        :actions= "types"
        v-model="sheetTypesVisible">
    </mt-actionsheet>

    <!-- <mt-actionsheet
        :actions= "areas"
        v-model="sheetAreasVisible">
    </mt-actionsheet> -->

    <ActionSheet style="z-index:9;" v-bind:visible="sheetAreasVisible" v-bind:close="closeAreaFilter" v-bind:itemArray="areas"></ActionSheet>

    <div style="display:flex;" id="type">
      <!--原来是 红色血脉 红医仁医 3D体验馆-->
      <!-- <span @click="showTypeFilter()" style="color:rgb(68, 85, 102);font-weight:bold;"><i class="iconfont sousuo"></i>红色血脉</span>
      <span @click="showAreaFilter()" style="color:rgb(68, 85, 102);font-weight:bold;"><i class="iconfont icon-Username"></i>红医仁医</span> -->
      <!-- <span @click="typeOne()"><i class="iconfont zuixin-green"></i>最美逆行者</span> -->
      <!-- <span @click="show3D()" style="color:rgb(68, 85, 102);font-weight:bold;"><i class="iconfont zuixin-green"></i>3D体验馆</span> -->
      <span @click="show3D()" style="color:rgb(68, 85, 102);font-weight:bold;"><i class="iconfont zuixin-green"></i>百年芳华</span> 
      <span @click="showAreaFilter()" style="color:rgb(68, 85, 102);font-weight:bold;"><i class="iconfont icon-Username"></i>高山仰止</span>
      <span @click="showTypeFilter()" style="color:rgb(68, 85, 102);font-weight:bold;"><i class="iconfont sousuo"></i>时代新人</span>
      <span  style="color:rgb(68, 85, 102);font-weight:bold;"><i class="iconfont zuixin-green"></i>桃李芬芳</span> 
    </div>

  <div v-infinite-scroll="loadMore" infinite-scroll-disabled="isLoadAll" infinite-scroll-distance="0" infinite-scroll-immediate-check="false">

    <div v-for="(sizheng,index) in sizhengs" style="margin-left:8px;margin-right:8px;margin-bottom:12px;padding-top:8px;border-top:1px solid #AAABB0;">
      <div style="display:flex;">
        <div style="flex:2;">
          <img :src="sizheng.hospitalImg" style="height:18px;width:18px;vertical-align:text-top;margin-right:4px;">
          <span style="font-size: .6rem;">{{sizheng.hospitalName}}</span>
        </div>

        <div style="flex:1;text-align:center;">
          <CollectElement v-bind:collect-data="sizheng" v-bind:collect-state="sizheng.collectionType" v-bind:collect-id="sizheng.id" v-bind:collect-type="'sizhengCollect'"></CollectElement>
        </div>
      </div>

      <div @click="goSizheng(sizheng.link)">

        <h4 style="margin-left:17px;margin-right:17px;margin-top:12px;margin-bottom:12px;font-size:18px;font-family: 'Helvetica Neue', Helvetica, STHeiTi, sans-serif;color: #456;font-weight:bold;">{{sizheng.title}}</h4>
        <p style="margin-left:17px;margin-right:17px;font-size:13px;font-family: 'Helvetica Neue', Helvetica, STHeiTi, sans-serif;color: #AAABB0;">{{limitLen(sizheng.content,100)}}</p>
        <div style="display:flex;margin-left:17px;margin-right:17px;margin-top:8px;">
          <div v-for="image in sizheng.images" style="text-align:center;flex:1;padding-right:2px;margin-bottom:9px;">
            <img :src="image" style="width:100%;height:100%;padding-left:2px;vertical-align:text-top;">
          </div>
        </div>
      
        <div style="margin-left:17px;">
          <mt-badge style="margin-right:4px;margin-bottom:4px;" size="small" color="#888" v-for="item in sizheng.types">{{types[(item-1)].name}}</mt-badge>
        </div>

      </div>
      
    </div>

  </div>
  <!-- <div style="height:35px;"></div> -->
                
    <!-- <div class="head"><img src="../assets/banner1.png" alt="">张老师</div>
    <div class="item">
      <mt-cell title="个人资料" to="/personalData">
        <span class="icon-go"></span>
        <i slot="icon" class="icon icon-my"></i>
      </mt-cell>
      <mt-cell title="我的订单" to="/myOrder">
        <span class="icon-go"></span>
        <i slot="icon" class="icon icon-order"></i>
      </mt-cell>

      <span @click="logOut">
        <mt-cell title="退出">
            <span class="icon-go"></span>
            <i slot="icon" class="icon icon-out"></i>
        </mt-cell>
      </span>
    </div> -->

  </div>
</template>
<script>
import openUrl from "./../utils/openUrl";
import logApi from "../api/users";
import L from "leaflet";
// import 'leaflet/dist/leaflet.css'
import cfg from "./../utils/config";
import axios from "axios";
import Addr from "./../utils/getAPI";
import Vue from "vue";
import store from "@/store/index";
import { Toast } from "mint-ui";
import commonHeader from "./../components/common-header.vue";
import ActionSheet from "./../components/actionsheet.vue";
import CollectElement from "@/components/collect";
export default {
  name: "learingMy",
  data() {
    return {
      heightSize: 240,
      types: [
        {
          id: 1,
          name: "中国工农军卫生学校",
          method: this.typeNine
          // url: require("./img/type/1.png")
        },
        {
          id: 2,
          name: "江西雩都红军军医学校",
          method: this.typeTen
          // url: require("./img/type/2.png")
        },
        {
          id: 3,
          name: "中国医科大学",
          method: this.typeEleven
          // url: require("./img/type/3.png")
        },
        {
          id: 4,
          name: "哈尔滨医科大学",
          method: this.typeTwelve
          // url: require("./img/type/4.png")
        }
      ],
      // types: [
      //   {
      //     id: 1,
      //     name: "校院班子联系点",
      //     method: this.typeOne
      //     // url: require("./img/type/1.png")
      //   },
      //   {
      //     id: 2,
      //     name: "兼职班主任",
      //     method: this.typeTwo
      //     // url: require("./img/type/2.png")
      //   },
      //   {
      //     id: 3,
      //     name: "导师负责制",
      //     method: this.typeThree
      //     // url: require("./img/type/3.png")
      //   },
      //   {
      //     id: 4,
      //     name: "党员群众手牵手",
      //     method: this.typeFour
      //     // url: require("./img/type/4.png")
      //   }
      // ],
      areas: [
        {
          text: "伍连德",
          name: "伍连德",
          method: this.typeTwo,
          img: Addr.getCdnAddr()+"qiniu/doctor/wuliande.jpg"
        },
        {
          text: "于维汉",
          name: "于维汉",
          method: this.typeThree,
          img: Addr.getCdnAddr()+"qiniu/doctor/yuweihan.jpg"
        },
        {
          text: "赵士杰",
          name: "赵士杰",
          method: this.typeFour,
          img: Addr.getCdnAddr()+"qiniu/doctor/zhaoshijie.jpg"
        },
        {
          text: "张亭栋",
          name: "张亭栋",
          method: this.typeFive,
          img: Addr.getCdnAddr()+"qiniu/doctor/zhangtingdong.jpg"
        },
        {
          text: "夏求明",
          name: "夏求明",
          method: this.typeSix,
          img: Addr.getCdnAddr()+"qiniu/doctor/xiaqiuming.jpg"
        },

        {
          text: "李秋洁",
          name: "李秋洁",
          method: this.typeSeven,
          img: Addr.getCdnAddr()+"qiniu/doctor/liqiujie.jpg"
        },
        {
          text: "杨宝峰",
          name: "杨宝峰",
          method: this.typeEight,
          img: Addr.getCdnAddr()+"qiniu/doctor/yangbaofeng.jpg"
        },
        {
          text: "\t张\t学\t",
          name: "\t张\t学\t",
          method: this.typeThirteen,
          img: Addr.getCdnAddr()+"qiniu/doctor/zhangxue.jpg"
        }
      ],
      // areas: [
      //   {
      //     name: "哈尔滨医科大学校部",
      //     method: this.areaOne
      //     // url: require("./img/0.jpg")
      //   },
      //   {
      //     name: "哈尔滨医科大学附属第一医院",
      //     method: this.areaTwo
      //     // url: require("./img/1.jpg")
      //   },
      //   {
      //     name: "哈尔滨医科大学附属第二医院",
      //     method: this.areaThree
      //     // url: require("./img/2.jpg")
      //   },
      //   {
      //     name: "哈尔滨医科大学附属肿瘤医院",
      //     method: this.areaFour
      //     // url: require("./img/3.jpg")
      //   },
      //   {
      //     name: "哈尔滨医科大学第四附属医院",
      //     method: this.areaFive
      //     // url: require("./img/4.jpg")
      //   },

      //   {
      //     name: "哈尔滨医科大学大庆校区",
      //     method: this.areaSix
      //     // url: require("./img/5.jpg")
      //   }
      // ],
      sheetTypesVisible: false,
      sheetAreasVisible: false,
      pageRow: 5,
      pageNum: 1,
      schools: [
        {
          name: "哈尔滨医科大学校部",
          longitude: 126.61517690867188,
          latitude: 45.70193845158804,
          link: "http://www.hrbmu.edu.cn/"
          // img: "school5"
        },
        {
          name: "哈尔滨医科大学附属第一医院",
          longitude: 126.64264272898438,
          latitude: 45.76506811390762,
          link: "http://www.54dr.org.cn/"
          // img: "school3"
        },
        {
          name: "哈尔滨医科大学附属第二医院",
          longitude: 126.6149837896228,
          latitude: 45.69311109116647,
          link: "http://www.hrbmush.edu.cn/"
          // img: "school6"
        },
        {
          name: "哈尔滨医科大学附属肿瘤医院",
          longitude: 126.63365196436646,
          latitude: 45.69495461092313,
          link: "http://hmucancerhospital.org.cn/"
          // img: "school2"
        },
        {
          name: "哈尔滨医科大学第四附属医院",
          longitude: 126.63146328181031,
          latitude: 45.76111618005954,
          link: "http://www.ydsy.cn/"
          // img: "school1"
        },
        {
          name: "哈尔滨医科大学大庆校区",
          longitude: 125.16169689595701,
          latitude: 46.59620580915154,
          link: "http://www.hmudq.edu.cn/"
          // img: "school7"
        }
      ],
      sizhengs: [],
      allSizhengs: [],
      isLoadAll: false
    };
  },
  methods: {
    loadMore() {
      if (this.isLoadAll == true) {
        Toast({
          message: "已全部加载",
          position: "bottom",
          duration: 800
        });
        return;
      }
      this.pageNum++;

      axios
        .get(
          Addr.getGoNewAPIPrefix() +
            "sizheng/listSizheng?pageNum=" +
            this.pageNum +
            "&pageRow=" +
            this.pageRow +
            "&id=" +
            this.$store.state.mineStore.userId
        )
        .then(res => {
          console.log("res is:");
          console.log(res);
          if (res.data.returnCode == 100) {
            if (res.data.returnData.list == null) {
              this.isLoadAll = true;
              Toast({
                message: "已全部加载",
                position: "bottom",
                duration: 800
              });
              return;
            } else {
              Toast({
                message: "已加载",
                position: "bottom",
                duration: 800
              });
              let tpsizhengs = [];
              if (this.type != null) {
                res.data.returnData.list.forEach(item => {
                  for (var i = 0; i < item.types.length; i++) {
                    if (item.types[i] == this.type) {
                      tpsizhengs.push(item);
                      break;
                    }
                  }
                });
              } else {
                tpsizhengs = res.data.returnData.list;
              }
              let ttppsizhengs = [];
              if (this.area != null) {
                tpsizhengs.forEach(item => {
                  if (item.hospitalName == this.area) {
                    ttppsizhengs.push(item);
                  }
                });
              } else {
                ttppsizhengs = tpsizhengs;
              }
              // this.sizhengs.push.apply(this.sizhengs, res.data.returnData.list);
              this.sizhengs.push.apply(this.sizhengs, ttppsizhengs);
              if (this.allSizhengs.length != 0) {
                this.allSizhengs.push.apply(
                  this.allSizhengs,
                  res.data.returnData.list
                );
              }
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    filterArea(name) {
      this.area = name;
      if (this.allSizhengs.length != 0) {
        this.sizhengs = this.allSizhengs;
      }

      console.log("area name is:" + name);
      let filterSizhengs = [];
      this.sizhengs.forEach(item => {
        if (item.hospitalName == name) {
          filterSizhengs.push(item);
        }
      });
      this.allSizhengs = this.sizhengs;
      this.sizhengs = filterSizhengs;
    },
    typeOne() {
      this.filterType(1);
    },
    typeTwo() {
      this.filterType(2);
    },
    typeThree() {
      this.filterType(3);
    },
    typeFour() {
      this.filterType(4);
    },
    typeFive() {
      this.filterType(5);
    },
    typeSix() {
      this.filterType(6);
    },
    typeSeven() {
      this.filterType(7);
    },
    typeEight() {
      this.filterType(8);
    },
    typeNine() {
      this.filterType(9);
    },
    //张学 20200615
    typeThirteen() {
      this.filterType(13);
    },
    //3D体验馆
    show3D() {
      this.filterType(14);
    },
    typeTen() {
      this.filterType(10);
    },
    typeEleven() {
      this.filterType(11);
    },
    typeTwelve() {
      // this.filterType(12);
      openUrl.open("https://beyond.3dnest.cn/play/index.html?m=577cfd1a_DeU4_b6f9&o=1&from=singlemessage&isappinstalled=0");
    },
    filterType(properties) {
      axios
        .get(
          Addr.getGoNewAPIPrefix() +
            "sizheng/listSizhengSpecial?pro=" +
            properties 
        )
        .then(res => {
          console.log("res is:");
          console.log(res);
          if (res.data.returnCode == 100) {
            if (res.data.returnData.list == null) {
              this.isLoadAll = true;
              Toast({
                message: "数据为空",
                position: "bottom",
                duration: 800
              });
              return;
            } else {
              this.sizhengs=res.data.returnData.list;
              //单独类别 设置已全部加载
              this.isLoadAll = true;
            }
          }
        })
        .catch(err => {
          console.log(err);
        });

      // console.log("properties is:"+properties);
      // this.properties = properties;
      // // console.log("type name is:" + name);
      // if (this.allSizhengs.length != 0) {
      //   this.sizhengs = this.allSizhengs;
      // }

      // // console.log("area name is:" + name);
      // let filterSizhengs = [];
      // this.sizhengs.forEach(item => {
      //   if (item.properties) {
      //     console.log("item.properties is:"+item.properties);
      //     for (var i = 0; i < item.properties.length; i++) {
      //       if (item.properties[i] == properties) {
      //         filterSizhengs.push(item);
      //         break;
      //       }
      //     }
      //   }
      // });
      // this.allSizhengs = this.sizhengs;
      // this.sizhengs = filterSizhengs;
    },
    showAll() {
      // this.area = null;
      // this.type = null;
      if (this.allSizhengs.length != 0) {
        this.sizhengs = this.allSizhengs;
      }
    },
    closeAreaFilter() {
      this.sheetAreasVisible = false;
    },
    showAreaFilter() {
      this.sheetAreasVisible = true;
    },
    showTypeFilter() {
      this.sheetTypesVisible = true;
    },
    goSizheng(link) {
      //window.location.href = link;
      openUrl.open(link);
    },
    //限制长度
    limitLen(content, maxLen) {
      return content.length > maxLen
        ? content.slice(0, maxLen) + "..."
        : content + "...";
    },
    init() {
      axios
        .get(
          Addr.getGoNewAPIPrefix() +
            "sizheng/listSizheng?pageNum=" +
            this.pageNum +
            "&pageRow=" +
            this.pageRow +
            "&id=" +
            this.$store.state.mineStore.userId
        )
        .then(res => {
          console.log("res is:");
          console.log(res);
          if (res.data.returnCode == 100) {
            this.sizhengs = res.data.returnData.list;

            // for(Object sizheng in this.sizhengs){
            //   sizheng.collectionType=false;
            // }

            // this.sizhengs.forEach(function(value, index, array) {
            //   array[index].collectionType = false;
            // });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    logOut: function() {
      logApi.logOut((ret, err) => {
        if (err) {
          console.log("退出失败！");
        } else {
          this.$store.commit("clear");
          this.$router.push("/login");
        }
        this.$store.commit("clear");
        this.$router.push("/login");
      });
    },
    mapInit() {
      let map = L.map("map", {
        center: [45.74740199642105, 126.65817975997926],
        zoom: 11
      });
      // 影像
      L.tileLayer(
        "http://t{s}.tianditu.com/img_w/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=img&tileMatrixSet=w&TileMatrix={z}&TileRow={y}&TileCol={x}&style=default&format=tiles&tk=b256e08b9f972a2c4677ab5608a305ff",
        {
          subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"]
        }
      ).addTo(map);
      // 地名标注
      L.tileLayer(
        "http://t{s}.tianditu.com/cia_w/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=cia&tileMatrixSet=w&TileMatrix={z}&TileRow={y}&TileCol={x}&style=default&format=tiles&tk=b256e08b9f972a2c4677ab5608a305ff",
        {
          subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"]
        }
      ).addTo(map);
      // 边界
      L.tileLayer(
        "http://t{s}.tianditu.com/ibo_w/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=ibo&tileMatrixSet=w&TileMatrix={z}&TileRow={y}&TileCol={x}&style=default&format=tiles&tk=b256e08b9f972a2c4677ab5608a305ff",
        {
          subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"]
        }
      ).addTo(map);

      let _self = this;

      console.log(_self.schools);

      _self.schools.forEach(item => {
        var linkComponent = Vue.extend({
          // template: '<a @click="goArea('+item.name+','+item.img+')">' + item.name + '</a>',
          template: '<a @click="goArea()">' + item.name + "</a>",
          methods: {
            goArea() {
              //window.location.href = item.link;
              openUrl.open(item.link);
            }
          }
        });
        var component = new linkComponent().$mount();

        var name = item.name;
        var marker = L.marker([item.latitude, item.longitude])
          .addTo(map)
          .bindPopup(
            component.$el
            // '<a>' + item.name + '</a>'

            // '<a href="' +
            // item.link +
            // "?name=" +
            // encodeURI(item.name) +
            // "&img=" +
            // item.img +
            // '">' +
            // item.name +
            // "></a>"
          );
      });
    }
  },
  mounted: function() {
    if (window.innerWidth > cfg.widthLimit) {
      this.heightSize = 360;
    }

    axios
      .get(Addr.getGoNewAPIPrefix() + "sizheng/listSizhengSchools")
      .then(res => {
        console.log("sizheng school res is:");
        console.log(res);
        if (res.status == 200) {
          console.log("200");
          this.schools=res.data;

          this.mapInit();
        }
      })
      .catch(err => {
        console.log(err);
      });

    // this.mapInit();
  },
  created: function() {
    this.init();
  },
  components: {
    ActionSheet,
    commonHeader,
    CollectElement
  }
};
</script>

<style lang="scss">
@import "../assets/baseScss";
.mint-actionsheet-listitem, .mint-actionsheet-button {
  color:rgb(68, 85, 102);
  font-weight: bold;
}
#type span {
  flex: 1;
  text-align: center;
  height: 35px;
  line-height: 35px;
}

.learingMy {
  text-align: left;
  .head {
    background: $cl1;
    padding: 30px 20px;
    line-height: 50px;
    color: $cl3;
    font-size: 20px;
    margin-bottom: 15px;
    img {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      margin-right: 10px;
      float: left;
    }
  }
  .item {
    background: $cl1;
    padding: 0 15px;
    li {
      line-height: 40px;
      border-bottom: solid 1px $cl5;
      position: relative;
      i {
        position: absolute;
        right: 0px;
      }
    }
    .icon {
      position: absolute;
      left: 0px;
      top: 15px;
      font-size: 18px;
    }
    .mint-cell-wrapper {
      position: relative;
      padding: 0px 0px 0px 25px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/module-my/index.vue